import { useQuery, UseQueryResult } from '@tanstack/react-query'

import { BusinessCategory } from '@/core/api/entities/businessCategory'
import { BusinessCategoryMapper } from '@/core/api/mappers/businessCategoryMapper'
import businessCategoryService from '@/core/api/services/businessCategoryService'

export function useBusinessCategories({
	config,
	options,
}: any = {}): UseQueryResult<BusinessCategory[], Error> {
	const QUERY_KEY = [
		'business_categories',
		{
			...config?.params,
		},
	]

	return useQuery({
		queryKey: QUERY_KEY,
		queryFn: () =>
			businessCategoryService.getBusinessCategories(config).then(({ data }) => {
				return BusinessCategoryMapper.toEntities(data.data)
			}),
		...options,
		cacheTime: 86400000, // 24h = 24h * 60m * 60s * 1000ms = 86400000ms
		staleTime: 86400000, // 24h = 24h * 60m * 60s * 1000ms = 86400000ms
	})
}
